import { Component, Inject } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl } from '@angular/forms';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';



import * as MandanteModel from './Mandante.model';


import { OpcionModel } from '../Global/Opcion.model';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { ConfirmarEliminacionService } from '../Dialog/ConfirmarEliminacionService';



@Component({
	selector: 'mandante',
	templateUrl: './MandanteIndex.component.html',
	styleUrls: ['../../../../styles.css']
})

/**
* @author Michael
* @since  02/04/2019
**/


export class MandanteIndexComponent {


	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar: boolean;
	public btnEditar: boolean;
	public btnEliminar: boolean;
	public btnConsultar: boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //


	public guardando: boolean;
	public displayedColumns = ['Negocio', 'Nombre', 'Nit', 'Editar'];
	public dataSource: ExampleDataSource;
	public patrimonios: Array<OpcionModel>;
	public patrimonio: OpcionModel;
	public mandantes: Array<MandanteModel.MandanteModel>;

	public prefijo :any;

	public ocultar: boolean = false;
	public mensaje: string = "";

	myControl = new FormControl();
	filteredOptions: Observable<OpcionModel[]>;
	options = [];

	public atras: boolean = false;


	constructor(private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog,
		private confirmarEliminacionService: ConfirmarEliminacionService) {
		this.guardando = false;
		this.patrimonios = new Array();
		this.patrimonio = new OpcionModel('', "");

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();
	}

	ngOnInit() {
		console.log('Inicia...');

		this.displayedColumns = ['identificacion', 'nombre', 'primerApellido', 'segundoApellido', 'opciones'];
		this.dataSource = new ExampleDataSource(null);
		this.iniciarLista();


	}

	

	filter(val: string)//: string[]
	{
		if (val == null) {
			val = "";
		}
		let x = this.patrimonios.filter(option => (option.idOpcion.toLowerCase().trim() + option.labelOpcion.toLowerCase().trim()).indexOf(val.toLowerCase()) > -1);

		return x;
	}


	iniciarLista() {

		this._serviciosGenerales.get('listaPatrimonios', { param: 0 }).subscribe(result => {
			for (let x of result) {
				this.patrimonios.push(new OpcionModel(x.cnumcont, x.vnombrenegocio));
			};

			this._route.params.subscribe(params => {
				this.patrimonio.idOpcion = params['cnumcont'];
				this.prefijo = params['cprefijo'];
				


				this.atras = (params['atras'] == undefined || params['atras'] == '' ? false : true);

				if (!!params['cnumcont']) {
					for (let x in this.patrimonios) {
						if (this.patrimonios[x].idOpcion.indexOf(params['cnumcont'].trim()) > -1) {
							this.patrimonio.labelOpcion = this.patrimonios[x].idOpcion.trim() + ' - ' + this.patrimonios[x].labelOpcion.trim();
							break;
						}
					}

					this.consultarMandantes();
				}

				this.filteredOptions = this.myControl.valueChanges
					.startWith(null)
					.map(val => val ? this.filter(val) : this.patrimonios.slice());
			})

		},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los patrimonios", "X");

			});
	}

	editarRegistro(registro) {
		
		this.patrimonio.idOpcion = this.patrimonio.labelOpcion.substring(0, this.patrimonio.labelOpcion.indexOf('-'));
		//console.log("Michael======//////>"+registro.id.cnumcont+"--"+registro.id.ctipid+"--"+registro.id.cnumid+"---"+this.patrimonio.idOpcion+"---"+this.prefijo); 
		
		this._router.navigate(['/Mandante', 'e', this.patrimonio.idOpcion, registro.id.cnumid,'si']);
	}


	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}



	eventoConsulta() {
		this.patrimonio.idOpcion = this.patrimonio.labelOpcion.substring(0, this.patrimonio.labelOpcion.indexOf('-'));
		console.log(this.patrimonio);
		this.consultarMandantes();
	}

	consultarMandantes() {


		console.log('Prefijo que llego'+this.prefijo);

		this._serviciosGenerales.get('mandantesAsociados', { cnumcont: this.patrimonio.idOpcion,cprefijo: this.prefijo}).subscribe(result => {
			this.dataSource = null;
			this.mandantes = new Array();
			/* console.log("Michael=====>" + this.patrimonio.idOpcion);
			console.log("carga ::::: "); */
			for (let x of result) {
				console.log(x);
				this.mandantes.push(new MandanteModel.MandanteModel(
					new MandanteModel.MchMandatariosId(x.cnumcont, x.ctipid, x.cnumid, x.ccodigo_contrato, 0),
					new MandanteModel.DefCiudades(x.ccodigociudad, x.ccodigodepto),
					new MandanteModel.DefTiposdocumentos(x.ctipid),
					new MandanteModel.DefTipospersona(x.ntipper),
					x.vnombre, x.vapellido, x.vapellido2, x.vdireccion, x.vnombrerut, x.nporcParticipacion, "", '', '',x.cprefijo,
					new MandanteModel.DefTiposIngreso(x.ntipoingreso)));
			};
			this.dataSource = new ExampleDataSource(this.mandantes);

		},

			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los terceros asociados", "X");

			});



		console.dir("xsfcdvs"+this.mandantes);
	}



	confirmacionDelete(mandante: MandanteModel.MandanteModel) {
		console.log({ cnumcont: mandante.id.cnumcont, ctipid: mandante.id.ctipid, cnumid: mandante.id.cnumid, ccodigo_contrato: mandante.id.ccodigoContrato, ntipoempresa: mandante.id.ntipoempresa });
		this.confirmarEliminacionService.abrirDialog(
			{ cnumcont: mandante.id.cnumcont, ctipid: mandante.id.ctipid, cnumid: mandante.id.cnumid, ccodigo_contrato: mandante.id.ccodigoContrato, ntipoempresa: mandante.id.ntipoempresa }, 'eliminarMandante');

		this.confirmarEliminacionService.eventoFin$.subscribe(r => {
			this.consultarMandantes();
		});
		console.log(mandante);
	}


	agregar(){
		console.log(this.patrimonio);
				if(this.mandantes.length != 0){
					this.openSnackBarEspecial("No se puede crear mas de un Mandante.", "X");
				}else
				 if(this.patrimonio.idOpcion == null || this.patrimonio.idOpcion.trim() == '' || this.patrimonio.idOpcion == undefined){
			this.openSnackBarEspecial("Debe seleccionar un neogcio para poder añadir un tercero.", "X");
		}else {

			let x = this.patrimonios.filter(option => option.idOpcion.toLowerCase().split(' ').join('') === this.patrimonio.idOpcion.toLowerCase().split(' ').join('') ); 
			console.log(x);

			if(x.length == 0){
				this.openSnackBarEspecial("El contrato: "+this.patrimonio.idOpcion.trim()+" no existe", "X");
			}else{
				this._router.navigate(['/Mandante','',this.patrimonio.idOpcion,'a','a']);		
				
			}
		}
	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1 notas");

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}

}

export class ExampleDataSource {

	public data: Array<MandanteModel.MandanteModel>;


	constructor(tercero: Array<MandanteModel.MandanteModel>) {
		this.data = new Array();


		if (tercero != null) {
			for (let i of tercero) {
				this.data.push(i);
			}
		}
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<MandanteModel.MandanteModel[]> {
		return Observable.of(this.data);
	}

	disconnect() {
	}
}

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //
@Component({
	selector: 'confirmacionDeleteMandante',
	templateUrl: 'confirmacionDeleteMandante.html',
})
export class DialogConfirmacion {

	constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Prefijo/MandanteIndex.component.ts